import { Link } from "react-router-dom";
import { UrlPath } from "utility/routes";

const Footer = () => {

  const handleDidomiClick = () => {
    if((window as any).Didomi?.preferences?.show) {
      (window as any).Didomi.preferences.show();
    }
  }

    return (<ul className="list-inline text-center mt-5">
  <li className="list-inline-item"><button className="text-secondary m-0 p-0 border-0 bg-transparent" onClick={handleDidomiClick}><small>Cookies</small></button></li>
  <li className="list-inline-item"><a className="text-secondary" href="https://min.1881.no/vilkaar-personvern/personvernerklaring"><small>Personvern</small></a></li>
  <li className="list-inline-item"><a className="text-secondary" href="https://min.1881.no/vilkaar-personvern/avtalevilkar-annonsering"><small>Avtalevilkår annonsering</small></a></li>
  <li className="list-inline-item"><Link to={UrlPath.ProductDescriptions} className="text-secondary"><small>Produktbeskrivelser</small></Link></li>
  <li className="list-inline-item"><a className="text-secondary" href="https://kundeservice.1881.no"><small>Kundeservice</small></a></li>
</ul>)
}

export default Footer;